import { WbTable } from '@agilelab/plugin-wb-platform';
import { TableCell, TableHead, TableRow } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { FC, useEffect } from 'react';
import { useReleaseDetailPageContext } from '../../context/useReleaseDetailPageContext';
import { useComponentsTableColumns } from '../../hooks/useComponentsTableColumns';
import { ComponentWithStatus } from '../../types';

export const ComponentsTable: FC = () => {
  const {
    fetchReleaseDescriptor,
    components,
    currentDescriptor,
    isPartialProvisioningEnabled,
    selectAllComponents,
    setSelection,
  } = useReleaseDetailPageContext();
  const columns = useComponentsTableColumns();
  if (isPartialProvisioningEnabled) {
    columns.unshift({
      field: 'selected',
      fieldRender: field => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {field.selected ? (
            <CheckBoxIcon
              onClick={() => {
                setSelection(field, false);
              }}
            />
          ) : (
            <CheckBoxOutlineBlankIcon
              onClick={() => {
                setSelection(field, true);
              }}
            />
          )}
        </div>
      ),
      cellProps: {
        width: '80px',
      },
    });
  }
  const allSelected =
    components.flat().filter((c: ComponentWithStatus) => !c.selected).length ===
    0;
  const style = {
    style: {
      fontWeight: 500,
      paddingLeft: '4px',
      paddingRight: '8px',
    },
  };

  useEffect(() => {
    fetchReleaseDescriptor();
  }, [fetchReleaseDescriptor]);

  return (
    <WbTable<ComponentWithStatus>
      stickyHeader
      components={{
        tableLoader: {
          loading: currentDescriptor === '',
        },
        tableContent: {
          columns,
          rows: currentDescriptor !== '' ? components : undefined,
        },
        tableHeader: (
          <TableHead>
            <TableRow>
              {isPartialProvisioningEnabled ? (
                <TableCell {...style} width={40}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {allSelected ? (
                      <CheckBoxIcon
                        onClick={() => {
                          selectAllComponents(false);
                        }}
                      />
                    ) : (
                      <CheckBoxOutlineBlankIcon
                        onClick={() => {
                          selectAllComponents(true);
                        }}
                      />
                    )}
                  </div>
                </TableCell>
              ) : (
                <></>
              )}
              <TableCell {...style}>Component</TableCell>
              <TableCell {...style}>Type</TableCell>
              <TableCell {...style}>Description</TableCell>
              <TableCell {...style}>Dependencies</TableCell>
              <TableCell {...style}>Status</TableCell>
            </TableRow>
          </TableHead>
        ),
      }}
    />
  );
};
